import { Component, OnInit } from '@angular/core';
import { HttpLoadingService } from '../service/http-loading.service';
import { TranslatePipe } from '@ngx-translate/core';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-http-loading',
    templateUrl: './http-loading.component.html',
    styleUrls: ['./http-loading.component.scss'],
    imports: [AsyncPipe, TranslatePipe]
})
export class HttpLoadingComponent implements OnInit {

  constructor(public _httpLoadingService: HttpLoadingService) { }

  ngOnInit(): void {
  }

}
